import SidebarComponent from './Sidebar/Sidebar'
import ContentComponent from './Content/Content'
import WrapperComponent from './Wrapper/Wrapper'

export const Sidebar = SidebarComponent
export const Content = ContentComponent
export const Wrapper = WrapperComponent
